/**
 * Determine which number format to use for a given payment setting.
 * @param paymentSettingType - see {@link PaymentSettingType}
 * @returns see {@link SliderNumberFormat}
 */
export const getPaymentNumberFormat = (
    paymentSettingType: PaymentSettingType,
): SliderNumberFormat =>
    paymentSettingType === 'QUARTERLY_ROYALTIES' ? 'USD' : 'none';
